export default "__VITE_ASSET__CGQJi$Yg__"